<!-- Header/Navigation -->
<app-header></app-header>

<!-- Main Content -->
<main>
  <!-- Hero Section -->
  <app-hero></app-hero>

  <!-- About Section -->
  <app-about></app-about>

  <!-- Services Section -->
  <app-services></app-services>

  <!-- Skills Section -->
  <app-skills></app-skills>

  <!-- Experience Section -->
  <app-experience></app-experience>

  <!-- Cases Section -->
  <app-cases></app-cases>

  <!-- Process Section -->
  <app-process></app-process>

  <!-- Location Section -->
  <app-location></app-location>

  <!-- Testimonials Section -->
  <app-testimonials></app-testimonials>

  <!-- Contact Section -->
  <app-contact></app-contact>
</main>

<!-- Footer -->
<footer class="bg-dark text-white py-5">
  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <h5 class="fw-bold mb-3">Portfolio</h5>
        <p class="text-muted">
          Full-stack developer creating modern web solutions with clean code and user-friendly design.
        </p>
      </div>
      <div class="col-lg-6 text-lg-end">
        <div class="social-links">
          <a href="#" class="text-white me-3" title="GitHub">
            <i class="fab fa-github fa-lg"></i>
          </a>
          <a href="#" class="text-white me-3" title="LinkedIn">
            <i class="fab fa-linkedin fa-lg"></i>
          </a>
          <a href="#" class="text-white me-3" title="Twitter">
            <i class="fab fa-twitter fa-lg"></i>
          </a>
          <a href="mailto:your.email&#64;example.com" class="text-white" title="Email">
            <i class="fas fa-envelope fa-lg"></i>
          </a>
        </div>
      </div>
    </div>
    <hr class="my-4">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <p class="text-muted mb-0">&copy; 2024 Portfolio. All rights reserved.</p>
      </div>
      <div class="col-lg-6 text-lg-end">
        <p class="text-muted mb-0">Made with <i class="fas fa-heart text-danger"></i> using Angular & Bootstrap</p>
      </div>
    </div>
  </div>
</footer>
